__turbopack_context__.v({
  "fallback": "image-with-fallback-module-scss-module__U9gUoa__fallback",
});
